module.exports = __webpack_public_path__ + "img/gruppo_mail_jobmule.98e73468.png";